@keyframes fadeInMoveDown {
    from {
      transform: translateY(-20px);
      opacity: 0;
    }
    to {
      transform: translateY(0);
      opacity: 1;
    }
  }
  
  /* Applied when div becomes visible */
  [data-visible-section='true'] {
    animation: fadeInMoveDown 1s forwards;
  }
